export default __webpack_public_path__ + "static/media/no_image.5ec37d20.png";